// Shared AdSense config (plain module so server and client components can both import it).

export const AD_CLIENT = "ca-pub-1617300496631636";

/**
 * Ad unit slots. All placements use the existing responsive display unit for now.
 * To track placements separately, create more units in AdSense and put their slot IDs here.
 */
export const AD_SLOTS = {
  homeTop: "4756005179",
  homeFeed: "4756005179",
  palDetail: "4756005179",
  palDetailBottom: "4756005179",
  breeding: "4756005179",
  items: "4756005179",
  skills: "4756005179",
  types: "4756005179",
} as const;
